/**
 * @license
 * Copyright Paysafe 2026. All rights reserved.
 */

import { Routes } from '@angular/router';

import { CheckoutErrorComponent } from './components/checkout-error/checkout-error.component';
import { CheckoutPreviewComponent } from './components/checkout-preview/checkout-preview.component';
import { CheckoutSuccessComponent } from './components/checkout-success/checkout-success.component';

export const routes: Routes = [
  {
    path: '',
    component: CheckoutPreviewComponent
  },
  {
    path: 'success',
    component: CheckoutSuccessComponent
  },
  {
    path: 'error',
    component: CheckoutErrorComponent
  }
];
